<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="noAction()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      @if (userType === 'STAFF') {
        @if (!addOrUpdateUserOptions.user.UserId) {
          <span>{{ 'Insert' | translate }}
            : {{ 'Users' | translate }}</span>
        } @else {
          <span>{{ 'Update' | translate }}
            : {{ 'Users' | translate }}</span>
        }
      } @else {
        @if (!addOrUpdateUserOptions.user.UserId) {
          <span>{{ 'Insert' | translate }}
            : {{ 'Client' | translate }}</span>
        } @else {
          <span>{{ 'Update' | translate }}
            : {{ 'Client' | translate }}</span>
        }
      }
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography">
  <div class="modal-body"
       style="position: relative;">
    <div class="my-4 pb-1 ">
      <div class="row">
        <div class="col-md-6 col-12">
          <app-frontend-input [(value)]="firstName"
                              [required]="true"
                              [title]="'FirstName'"
                              [type]="'text'"></app-frontend-input>
        </div>
        <div class="col-md-6 col-12">
          <app-frontend-input [(value)]="lastName"
                              [required]="true"
                              [title]="'LastName'"
                              [type]="'text'"></app-frontend-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-12">
          <app-frontend-input (input)="onMobileNumberInput($event)"
                              [(value)]="mobileNumber"
                              [required]="true"
                              [title]="'MobileNumber'"
                              [type]="'text'"></app-frontend-input>
        </div>
        <div class="col-md-6 col-12">
          <app-frontend-input (input)="onNationalCodeInput($event)"
                              [(value)]="nationalCode"
                              [required]="false"
                              [title]="'NationalCode'"
                              [type]="'text'"></app-frontend-input>
        </div>
        <div class="col-md-6 col-12">
          <app-frontend-input [(value)]="email"
                              [required]="false"
                              [title]="'Email'"
                              [type]="'text'"></app-frontend-input>
        </div>
        <div class="col-md-6 col-12">
          <app-frontend-check-box [(value)]="isActive"
                                  [title]="'IsActive'"></app-frontend-check-box>
        </div>
      </div>
      @if (userType === 'STAFF') {
        <div class="row">
          <div class="col-md-6 col-12">
            <app-frontend-select [(value)]="businessId"
                                 [controller]="'businesses'"
                                 [disabled]="addOrUpdateUserOptions.user.UserId !== undefined"
                                 [displayKey]="'Title'"
                                 [fieldName]="'BusinessId'"
                                 [method]="'get'"
                                 [microservice]="Constant.FOOD_SHOP"
                                 [protocolMethod]="'POST'"
                                 [required]="true"
                                 [searchOnKey]="'Title'"
                                 [selectedOptions]="getSelectedBusiness(businessId)"
                                 [title]="'Business'"
                                 [version]="'v1'"></app-frontend-select>
          </div>
          <div class="col-md-6 col-12">
            <app-frontend-input [(value)]="username"
                                [disabled]="addOrUpdateUserOptions.user.UserId"
                                [required]="true"
                                [title]="'UserName'"
                                [type]="'text'"></app-frontend-input>
          </div>
          <div class="col-md-6 col-12 d-flex">
            <app-frontend-button (click)="onConsumerAttributeClicked()"
                                 [Image]="true"
                                 [class]="'card-main'"
                                 [required]="true"
                                 [src]="'/icons/devices.svg'"
                                 [title]="'ConsumerAttributeIds'">
            </app-frontend-button>
          </div>
        </div>
        <div *ngIf="showRoles === true || addOrUpdateUserOptions.user.UserId">
          <hr>
          <h2 style="font-size: 16px;">{{ 'AssignARoleToAUser' | translate }}</h2>
          <div class="col-lg-2 col-md-4 col-6 p-0 w-100">
            <ng-container *ngFor="let role of roleList">
              <button (click)="onAssignRoleToStaff(role)"
                      [ngClass]="role.IsSelected ? 'btn-add' : 'btn-manager'">
                {{ role.Business.Title + ' > ' + role.Title }}
              </button>
            </ng-container>
          </div>
        </div>
      }
    </div>
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (onSubmit)="onSubmitClicked()"
                           [Image]="true"
                           [class]="'card-green'"
                           [disabled]="false"
                           [src]="'/icons/tick-square.svg'"
                           [title]="'Submit'"
                           [validationRequired]="true">
      </app-frontend-button>
      <app-frontend-button (click)="noAction()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'/icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
